import { colors } from "../../styles";

export default {
    downloadButtonStyles: {
        backgroundColor: colors.white,
        borderColor: colors.blue,
        color: colors.blue,
        borderRadius: 32,
        px: 2,
        py: 1,
        "&: hover": {
            backgroundColor: colors.blue,
            color: colors.white
        }
    }
};
